
<ul class="progress-bar__status-list">
  <li class="progress-bar__status-item" *ngFor="let group of groups" [class.progress-bar__status-item--group]="root"><i class="progress-bar__action-icon" *ngIf="root" [class.gw-cloud--off]="group.action === 'download'" [class.gw-cloud--sync]="group.action === 'sync'" [class.gw-attach]="group.action === 'upload'"></i><i class="progress-bar__status-icon" [ngClass]="getGroupClass(group.status)"></i>
    <div class="progress-bar__status-item-content">{{ group.name }}</div>
    <div class="progress-bar__status-item-children" *ngIf="group.children">
      <gw-progress-groups [groups]="group.children" [root]="false"></gw-progress-groups>
    </div>
  </li>
</ul>